import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { FlyoutModalComponent } from './flyout-modal.component';

@NgModule({
  imports: [CommonModule, ModalModule.forRoot()],
  declarations: [FlyoutModalComponent],
  exports: [FlyoutModalComponent]
})
export class FlyoutModalModule {}
